module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNiA0Ij48cGF0aCBmaWxsPSIjQ0UxMTI2IiBkPSJNMCAwaDZ2NEgweiIvPjxwYXRoIGZpbGw9IiMwMDM4OTMiIGQ9Ik0wIDBoNnYzSDB6Ii8+PHBhdGggZmlsbD0iI0ZDRDExNiIgZD0iTTAgMGg2djJIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/col.svg
// module id = gaj3
// module chunks = 0